define(["require", "exports", "@drklein/client-detection", "hypo_elements/Typescripts/Configuration/Configuration", "bootstrap", "hammerjs", "jquery"], function (require, exports, client_detection_1, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var $karussellsSelectorAll = $(".karussell");
        var $karussellsSelectorMobileEnabled = $(".karussell--is-mobile-enabled");
        var $enabledKarussells = client_detection_1.MobileDetection.isMobile()
            ? $karussellsSelectorMobileEnabled
            : $karussellsSelectorAll;
        $enabledKarussells.each(function (index, element) {
            var $karussell = $(element);
            configureKarussell($karussell);
            addNavigationOnSwipeEvent($karussell);
        });
        function addNavigationOnSwipeEvent($karussell) {
            var karussellDomElement = $karussell[0];
            if (karussellDomElement) {
                var hammerElement = new Hammer(karussellDomElement);
                hammerElement.on("swipeleft panleft", function () {
                    $karussell.carousel("next");
                });
                hammerElement.on("swiperight panright", function () {
                    $karussell.carousel("prev");
                });
            }
        }
        function configureKarussell($karussell) {
            $karussell
                .addClass("slide")
                .carousel({
                interval: Configuration_1.configuration.karussellAnimationIntervalInMs,
            });
        }
    });
});
